// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aL92m{display:flex;align-items:center;gap:8px}.Lem9Q{width:100%}.Lem9Q>:first-child{flex:1}.tOett{padding:0 4px;display:flex;gap:4px;flex-shrink:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `aL92m`,
	"rootMobile": `Lem9Q`,
	"buttons": `tOett`
};
export default ___CSS_LOADER_EXPORT___;
